export default class SolicitanteModel {
  constructor({
    id = 0,
    nome = '',
    cpf = null,
    rg = null,
    orgaoEmissor = null,
    dataNascimento = null,
    email = null,
    celular = null,
    enderecos = [],
    contatos = [
      {
        email: '',
        celular: '',
      },
    ],
  } = {}) {
    this.id = id
    this.nome = nome
    this.cpf = cpf
    this.rg = rg
    this.orgaoEmissor = orgaoEmissor
    this.dataNascimento = dataNascimento
    this.email = email
    this.celular = celular
    this.enderecos = enderecos
    this.contatos = contatos
  }
}
